export const environment = {
  production: true,
  apiUrl: "https://api.actnowillinois.org/api/",
  subdomains: true,
  hostbase: "actnowillinois.org",
  editorBypassValidation: false
};



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/environments/environment.ts